import { HttpClient, HttpParams} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PricebookService {

  constructor(private http: HttpClient) { }

  getAllPricingTiers(){
    return this.http.get<any>(`${environment.inventoryURl}PriceTier/GetAllPriceTierByType`);
  }

  getSetPriceTierConfig(status) {
    let params = new HttpParams();
    params = (status==undefined)? params: params.append('isEnable', status)
    return this.http.get<any>(`${environment.inventoryURl}PriceTier/PriceTierConfiguration`, {params});
  }

  getSetPriceTierConfigByVisibility(status, isVisibility: boolean) {
    let params = new HttpParams();
    params = (status==undefined)? params: params.append('isEnable', status)
    params = params.append('isVisibility', isVisibility)
    return this.http.get<any>(`${environment.inventoryURl}PriceTier/PriceTierConfiguration`, {params});
  }

  getAllPriceTierGroups(){
    return this.http.get<any>(`${environment.inventoryURl}Group`);
  }

  getAllPriceTierTypes(groupId){
    return this.http.get<any>(`${environment.inventoryURl}Type?groupId=${groupId}`);
  }

  checkDuplicateTier(tierId,name){
    return this.http.get<any>(`${environment.inventoryURl}PriceTier/CheckDuplicatePriceTier?tierId=${tierId}&name=${name}`);
  }

  addPriceTier(value) {
    return this.http.post<any>(`${environment.inventoryURl}PriceTier`, value)
      .toPromise()
      .then(res => res);
  }

  updatePriceTier(value) {
    return this.http.put<any>(`${environment.inventoryURl}PriceTier`, value)
      .toPromise()
      .then(res => res);
  }

  deletePriceTier(id) {
    return this.http.delete<any>(`${environment.inventoryURl}PriceTier/${id}`)
      .toPromise()
      .then(res => res);
  }

  getConfigurationsByModuleName(configName){
    return this.http.get<any>(`${environment.configUrl}Configuration/ConfigurationsByModuleName?name=${configName}`)
  }

  getInventoryGroupList() {
    return this.http.get<any>(`${environment.inventoryURl}Group`);
  }

  getInventoryCategoryList(groupId) {
    return this.http.get<any>(`${environment.inventoryURl}Category/CategoryHierarchy?groupId=${groupId}`);
  }

  getvendorsDD(): Observable<any>{
    return this.http.get<any>(`${environment.inventoryURl}Vendor/AllVendorDetails?PageSize=0&PageNumber=0&SearchValue=`);
}

  getAllItems(pageNo,pageSize,typeId,discountTypeId,categoryId,manufacturerId,warehouseId,searchValue,groupId){
    let params = new HttpParams();
    params = params.append('PageNumber', pageNo)
    params = params.append('PageSize', pageSize)
    params = params.append('typeId', typeId)
    params = params.append('tierTypeId', discountTypeId)
    params = (categoryId ? params.append('categoryId', categoryId) : params)
    params = (groupId ? params.append('groupId', groupId) : params)
    params = (manufacturerId ? params.append('manufacturerId', manufacturerId) : params)
    params = (warehouseId ? params.append('warehouseId', warehouseId) : params)
    params = (searchValue ? params.append('SearchValue', searchValue) : params)
     return this.http.get<any>(`${environment.inventoryURl}PriceTier/Products`,{observe: 'response',params})
         .toPromise()
         .then(res=> ({
             items: res.body,
             headers: JSON.parse(res.headers.get('x-pagination')) //{TotalCount: 91, PageSize: 10, CurrentPage: 1, TotalPages: 10, HasNext: true, HasPrevious: false});
         }))
  }

  addBulkPriceTier(value) {
    return this.http.post<any>(`${environment.inventoryURl}PriceTier/ProductPriceTier/BulkAddProductPriceTier`, value)
      .toPromise()
      .then(res => res);
  }

  addBulkProductToGroup(value) {
    return this.http.post<any>(`${environment.inventoryURl}PriceTier/ProductPriceTier/AddBulkGroupProductPriceTier`, value)
      .toPromise()
      .then(res => res);
  }

  applyAllBulkPriceTier(value) {
    return this.http.post<any>(`${environment.inventoryURl}PriceTier/ProductPriceTier/BulkAddProductGroupPriceTier`, value)
      .toPromise()
      .then(res => res);
  }

  getAllAssignedTiers(){
    return this.http.get<any>(`${environment.inventoryURl}PriceTierRules`);
  }

  addAssignedTierRule(data){
    return this.http.post<any>(`${environment.inventoryURl}PriceTierRules`, data)
    .toPromise()
    .then(res => res);
  }

  updateAssignedTierRule(data){
    return this.http.put<any>(`${environment.inventoryURl}PriceTierRules`, data)
    .toPromise()
    .then(res => res);
  }

  getAllAccounts(pageNo,pageSize,channelId,typeId,searchValue){
    let params = new HttpParams();
    params = params.append('PageNumber', pageNo)
    params = params.append('PageSize', pageSize)
    params = params.append('typeId', typeId)
    params = params.append('channelId', channelId)
    params = params.append('IsActive', true)
    params = (searchValue ? params.append('SearchValue', searchValue) : params)
     return this.http.get<any>(`${environment.apiUrlAccount}Account/AllAccountDetailsForPriceTier`,{observe: 'response',params})
         .toPromise()
         .then(res=> ({
             accounts: res.body,
             headers: JSON.parse(res.headers.get('x-pagination')) //{TotalCount: 91, PageSize: 10, CurrentPage: 1, TotalPages: 10, HasNext: true, HasPrevious: false});
         }))
  }

  updateBulkAssignedTierRule(data){
    return this.http.put<any>(`${environment.apiUrlAccount}AccountProductPriceTier/EditBulkAccountProductPriceTier`, data)
    .toPromise()
    .then(res => res);
  }

  getAllLocations(): Observable<any>{
    let params = new HttpParams();
    params = params.append('PageNumber', '0')
    params = params.append('PageSize', '0')
    params = params.append('SearchValue', '')
    return this.http.get<any>(`${environment.inventoryURl}WareHouse/AllWarehouseDetails`, { params });
}

 getAllDiscountOption(groupName){
  return this.http.get<any>(`${environment.inventoryURl}Type/GetAllTypeByGroupOrganization?groupName=${groupName}`);
 }

 setDefaultDiscountOption(data){
  return this.http.put<any>(`${environment.inventoryURl}Type/SetPriceTierDiscount`, data)
  .toPromise()
  .then(res => res);
 }

}
